import React from "react";
import { useAdminOrderStore } from "../../store/useAdminOrderStore.ts";

const AdminOrderTabs = () => {
  const { activeTab, setActiveTab } = useAdminOrderStore();

  const tabs = [
    { key: "CURRENT", label: "جاری" },
    { key: "DELIVERED", label: "تحویل شده" },
    { key: "RETURNED", label: "مرجوع شده" },
    { key: "CANCELLED", label: "لغو شده" },
  ];

  const handleTabClick = (tabKey) => {
    if (activeTab === tabKey) {
      return;
    }

    setActiveTab(tabKey);
  };

  return (
    <div className="mb-6 border-b border-gray-200">
      <nav className="flex space-x-8 overflow-x-auto pb-2 -mb-px">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => handleTabClick(tab.key)}
            className={`px-1 py-3 text-sm font-medium whitespace-nowrap ${
              activeTab === tab.key
                ? "border-b-2 border-blue-600 text-blue-600"
                : "border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default AdminOrderTabs;
